export default __webpack_public_path__ + "static/media/main_bg_pentagon1.35924c39.svg";